import {
  ExemptionCertificateSubmission,
  ExemptionCertificateTemplate,
  ExemptionCustomerSellerRelationship,
} from '@commenda/prisma';

// TODO (MILEK): Move Sales Tax Types to @commenda/types
export type GetSubmissionResponse = ExemptionCertificateSubmission & {
  customerSellerRelationship: Partial<ExemptionCustomerSellerRelationship>;
  template?: Partial<ExemptionCertificateTemplate>;
  derivedStatus?: SubmissionStatusFilter;
};

export type ExemptionPortalStatusOptions = SubmissionStatusFilter | 'ALL';

enum SubmissionStatusFilter {
  APPROVED = 'APPROVED',
  UNDER_REVIEW = 'UNDER_REVIEW',
  EXPIRING_SOON = 'EXPIRING_SOON',
  EXPIRED = 'EXPIRED',
  REJECTED = 'REJECTED',
}

export class ExemptionPortalHelper {
  static DERIVED_STATUS_NAME_MAP: Record<SubmissionStatusFilter, string> = {
    [SubmissionStatusFilter.APPROVED]: 'Approved',
    [SubmissionStatusFilter.UNDER_REVIEW]: 'Under Review',
    [SubmissionStatusFilter.EXPIRING_SOON]: 'Expiring Soon',
    [SubmissionStatusFilter.EXPIRED]: 'Expired',
    [SubmissionStatusFilter.REJECTED]: 'Rejected',
  };

  static getSubmissionStatusBadgeVariant = (status: SubmissionStatusFilter) => {
    switch (status) {
      case SubmissionStatusFilter.APPROVED:
        return 'success';
      case SubmissionStatusFilter.UNDER_REVIEW:
        return 'warning';
      case SubmissionStatusFilter.REJECTED:
        return 'error';
      case SubmissionStatusFilter.EXPIRING_SOON:
        return 'warning';
      case SubmissionStatusFilter.EXPIRED:
        return 'error';
      default:
        return 'gray';
    }
  };

  static getExemptionCertificateCountForStatus = (
    submissions: GetSubmissionResponse[],
    status: SubmissionStatusFilter
  ) => {
    const filteredSubmissions =
      submissions?.filter(
        (submission) => submission.derivedStatus === status
      ) ?? [];
    return filteredSubmissions.length;
  };

  static getFilteredExemptionCertificates = (
    submissions: GetSubmissionResponse[],
    status: ExemptionPortalStatusOptions
  ) => {
    if (status === 'ALL') {
      return submissions;
    }

    return (
      submissions?.filter(
        (submission) => submission.derivedStatus === status
      ) ?? []
    );
  };
}
